import { LuFilter } from 'react-icons/lu'
import { useTheme } from '@mui/material/styles'
import Button, { ButtonProps } from '@mui/material/Button'
import useNode from '../models/useNode'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import useNodeMetadata from '../models/useNodeMetadata'
import useServices from '../models/useServices'
import useUpgrades from '../models/useUpgrades'
import useSetPlaces from '../models/useSetPlaces'

export default function Filter(props: ButtonProps) {
  const theme = useTheme()
  const { get: getNodes, hideOffline, set } = useNode()
  const { get: getNodeMetadata } = useNodeMetadata()
  const { get: getServices } = useServices()
  const getUpgrades = useUpgrades(state => state.get)
  const getSetPlaces = useSetPlaces(state => state.get)

  const clickHandler = async () => {
    set({ hideOffline: !hideOffline })
    await getNodes()
    // ⚠ After the nodes: each reads for the node ids the store holds. Together, as in
    // `controller.loadState`: they do not wait for each other, and none of them rejects.
    await Promise.all([getNodeMetadata(), getServices(), getUpgrades(), getSetPlaces()])
  }

  return (
    <Button onClick={clickHandler} {...props}>
      <Typography variant="caption" color={props.disabled ? 'textDisabled' : 'textSecondary'} sx={{
        lineHeight: 1.2
      }}>
        {hideOffline ? 'Show Offline' : 'Show Recent'}
      </Typography>
      <Stack
        sx={{
          width: 38,
          height: 38,
          alignItems: 'center',
          justifyContent: 'center',
          color: 'contrast.medium'
        }}>
        <LuFilter fontSize={20} color={props.disabled ? theme.palette.contrast.low : undefined} />
      </Stack>
    </Button>
  )
} 
